import { lineFamilyOf } from './line-family.js';
/**
 * The family an order's existing lines have established, or `null` if it has none yet
 * (no lines, or only lines outside the mixing rule). A well-formed order never has lines from
 * both families at once — see `canAddLineType` for the write-path guard that enforces this —
 * but this reads the first family-bearing line it finds so it degrades gracefully for
 * ETL-migrated legacy orders that predate the rule.
 */
export function orderLineFamily(items) {
    for (const item of items) {
        const family = lineFamilyOf(item.typeId);
        if (family)
            return family;
    }
    return null;
}
//# sourceMappingURL=order-line-family.js.map